/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React, { useState } from "react";
import { Button, Nav, Navbar, Container } from "react-bootstrap";
import {
  Routes,
  Route,
  Link,
  Navigate,
  useNavigate,
  useLocation,
} from 'react-router-dom';

import { AuthProvider, useAuth, useDispatcher } from "./components/AuthProvider";

import UserLogin from "./pages/UserLogin";
import UserRegistration from "./pages/UserRegistration";
import RegistrationComplete from "./pages/RegistrationComplete";
import UserVerification from "./pages/UserVerification";

import ModelGallery from "./pages/ModelGallery";
//import ModelDashboard from "./pages/ModelDashboard";
import Planner from "./pages/Planner";

import CalculatorPanel from "./pages/CalculatorGallery/CalculatorPanel";
import CanadaPayrollCalc from "./pages/Calculators/CanadaPayrollCalc";
import CanadaPayRequired from "./pages/Calculators/CanadaPayRequired";

import getPCPUrl from "./components/pcpUrl";




const ProtectedRoute = ({ children }) => {
  const { session } = useAuth();
  const location = useLocation();

  // 06-Jul-2024 JC
  // TODO Sometimes session is null, need to see the flow that causess this
  if (session === null || session.token === null) {
    return <Navigate to="/app/login" replace state={{ from: location }} />;
  }

  return children;
};


const App = () => {
  return (
    <AuthProvider>
      <Container fluid="lg">

        <Navigation />

        <Routes>

          <Route path="app/login" element={<UserLogin />} />
          <Route path="app/registration" element={<UserRegistration />} />
          <Route path="app/registered" element={<RegistrationComplete />} />
          <Route path="app/verification" element={<UserVerification />} />

          <Route path="app/calculators/canadapay" element={<CanadaPayrollCalc />} />
          <Route path="app/calculators/canadapayreq" element={<CanadaPayRequired />} />

          <Route
            path="app/gallery"
            element={
              <ProtectedRoute>
                <ModelGallery />
              </ProtectedRoute>
            }
          />

          <Route
            path="app/planner/*"
            element={
              <ProtectedRoute>
                <Planner />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<NoMatch />} />
        </Routes>

      </Container>

    </AuthProvider>
  );
};


const Navigation = () => {
  const { session } = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatcher();

  const logged_in = session === null ? false : session?.token === undefined ? false : session.token === null ? false : true; // TODO - IsAuthenticaed


  const fetchData = async (endpoint, body) => {
    let url = getPCPUrl() + endpoint;

    let results = {
      status: -1,
      body: null
    };

    //setIsError(false);
    //setIsLoading(true);

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'PCPAuthorization': session.token
        },
      });

      results.status = response.status;
    } catch (error) {
      let e = error;
      //setIsError(true);
    }

    //setIsLoading(false);
    console.log('login = done');

    return results;
  };


  const onLogout = async (event) => {
    event.preventDefault();

    let results = await fetchData("logout", "");
    if (results.status >= 200 && results.status <= 299) {
      let action = {
        type: 'logout',
      }

      dispatch(action);
      navigate("/app/login");
    }


  }

  // 05-Jul-2024 JC
  // To get the hamburger to disapear on selecting a link, it was adding the eventKey
  // along with the collapseOnSelect. I also changed to responsive-navbar-nav from basic-navbar-nav
  // but dont think that did anything.

  // 03-Nov-2024 JC
  // <Nav.Link eventKey={1} href="/calculators.html">Calculators</Nav.Link>
  // did this because it was not going to the html or at least not refreshing

  return (
    <Navbar collapseOnSelect bg="light" expand="lg">
      <Navbar.Brand href="/">Paycheck Planner</Navbar.Brand>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">

        <Nav className="me-auto">
          <Nav.Link eventKey={1} href="/calculators.html">Calculators</Nav.Link>
          <Nav.Link eventKey={2} as={Link} to="/app/gallery">Planner</Nav.Link>

          {!logged_in && (<Nav.Link eventKey={4} as={Link} to="/app/login">Login</Nav.Link>)}
          {logged_in && (
            <Button type="button" onClick={onLogout}>Sign Out</Button>
          )}

        </Nav>
      </Navbar.Collapse>


    </Navbar>
  );


};



const NoMatch = () => {
  return <p>There's nothing here: 404!</p>;
};


export default App;
